/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import CustomerDetailBlock from "../checkout/review/customerDetailsBlock";
import CartBlock from "../checkout/review/cartBlock";
import Button from "../../../component/button";
import classes from "../checkout/checkout.module.css";
import BusApiCall from "../../../helper/axios.js";
import Loader from "../../../component/loader";
import Tnc from "./tnc";
import { connect } from "react-redux";
import HeaderNoAuth from "../../../component/header/headerNoAuth";
import actionTypes from "../../../store/actions";
import constants from "../../../helper/constants";
import GenericBPMNForm from "../../../component/genericBPMNForm/genericBPMNForm";
import bpmnFormValidator from "../../../helper/bpmnFormValidator";
import { Grid } from "@mui/material";

// Confirm Order page parent class
class ConfirmOrder extends Component {
  // Declare property values that belongs to the component
  state = {
    customerDetails: {},
    stage: 4,
    orderId: "",
    show: false,
    showCloseButton: false,
    tyMsg: "",
    loading: false,
    token: "",
    solutions: [],
    accessories: [],
    terms: [],
    customerPartyId: "",
    username: "",
    orderStatus: "",
    acted_by: "",
    acted_title: "",
    ipAddress: "",
    headerMap: null,
    orderTermStatus: null,
    providerTitle: "",
    tenantId: null,
    taskFormData: {},
    workFlowEnabled: false,
  };
  // Page constructor
  constructor(props) {
    super(props);
    // Bind function
    this.onChange = this.onChange.bind(this);
  }

  // this function is used to get user IP address
  getIp() {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((json) => {
        this.setState({ ipAddress: json.ip });
      });
  }

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    // Remove error message on component load
    this.props.setCompDidMount();
    // Show loader
    this.setState({ loading: true });
    // Call getIp() function
    this.getIp();
    const params = new URLSearchParams(this.props.router.location.search);
    // Get order id and token from URL params
    const token = params.get("token");
    let tenantId = params.get("tenantId");
    this.state.tenantId = tenantId;
    let orderIdUrlParam = this.props.router.params.id;

    // Fetch theme data
    BusApiCall(
      "GET",
      `${constants.busOpenServiceUrl}/tenants/${tenantId}/themes`,
    ).then((theme) => {
      let tenantData = {};
      for (var i = 0; i < theme.data.length; i++) {
        tenantData[theme.data[i].key] = theme.data[i].value;
      }
      this.setState({
        providerTitle: tenantData.title,
      });
      this.props.setTenantData(tenantData);
      this.props.setTenantId(tenantId);
    });

    // Fetch confirm order data
    BusApiCall(
      "GET",
      `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/orders/${orderIdUrlParam}?token=${token}`,
    )
      .then((orderRes) => {
        let res = orderRes.data.orderSummary;
        this.setState({
          orderTermStatus: res.orderTermStatus,
        });
        // Fetch customer data
        BusApiCall(
          "GET",
          `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/orders/${orderIdUrlParam}/customers?token=${token}`,
        )
          .then((custResponse) => {
            // Extract Packaged Solution data
            let newSolutions = [];
            let newAccessories = [];
            for (let item of res.orderItems) {
              if (item.associatedProducts) {
                let data = {};
                // Start: Get packaged solution details
                data.name = item.productName;
                data.id = item.productId;
                data.quantity = JSON.parse(item.quantity);
                data.type = "SOL";
                data.discount = item.discount;
                // Start: Get packaged solution details

                // Check that addons and setup quantity in modifiable
                // Since in some products user can set their individual quantity
                // if (item.associatedProducts.some(obj => obj.associationType === 'SOLUTION_PLAN')) {
                // } else {
                //     data.addOnQuantMod = true;
                //     data.setupQuantMod = true;
                // }

                data.associatedItems = [];
                if (item.associatedProducts.length > 0) {
                  for (
                    var i = 0;
                    i < item.associatedProducts[0].products.length;
                    i++
                  ) {
                    item.associatedProducts[0].products[i].price =
                      this.setTempPrice(
                        item.associatedProducts[0].products[i].amount,
                        item.associatedProducts[0].products[i].chargeType,
                      );
                    if (i === item.associatedProducts[0].products.length - 1) {
                      data.associatedItems =
                        item.associatedProducts[0].products;
                    }
                  }
                }
                newSolutions.push(data);
              } else {
                // Get accessories
                let obj = {
                  id: item.productId,
                  name: item.productName,
                  quantity: +item.quantity,
                  price: +item.amount,
                };
                newAccessories.push(obj);
              }
            }
            // for (var i = 0; i < res.solutions.length; i++) {
            //     let solution = {
            //         name: res.solutions[i].name,
            //         id: res.solutions[i].id,
            //         quantity: res.solutions[i].quantity,
            //         index: i,
            //         // type: "SOL",
            //         discount: res.solutions[i].discount,
            //         associatedItems: []
            //     }
            //     let items = res.solutions[i].solution;
            //     for (var j = 0; j < items.length; j++) {
            //         let item = {
            //             // amount: 24.99,
            //             quantity: items[j].quantity,
            //             productId: items[j].id,
            //             // chargeType: "RC",
            //             productName: items[j].name,
            //             price: items[j].price,
            //             customerViewable: items[j].customerViewable
            //         }
            //         solution.associatedItems.push(item);
            //     }
            //     newSolutions.push(solution);
            // }
            // for (var i = 0; i < res.solutions.length; i++) {
            //     if (!res.solutions[i].isStandAlone) {
            //         newSolutions.push(res.solutions[i])
            //     } else {
            //         let obj = {
            //             id: res.solutions[i].id,
            //             name: res.solutions[i].name,
            //             quantity: +res.solutions[i].quantity,
            //             price: +res.solutions[i].price.purchasePrice
            //         }
            //         newAccessories.push(obj)
            //     }
            // }
            // Extract accessories data
            // for (let item of res.accessories) {
            //     let obj = {
            //         id: item.id,
            //         name: item.name,
            //         quantity: +item.quantity,
            //         price: +item.price
            //     }
            //     newAccessories.push(obj)
            // }
            this.setState(
              {
                customerDetails: custResponse.data,
                show: true,
                loading: false,
                orderId: orderIdUrlParam,
                token,
                solutions: newSolutions,
                accessories: newAccessories,
                terms: [...res.terms],
                customerPartyId: res.customerPartyId,
                orderStatus: res.orderStatus,
                workFlowEnabled: res.workFlowEnabled
                  ? res.workFlowEnabled
                  : false,
              },
              () => {
                if (this.state.workFlowEnabled) {
                  this.getBPMNActions();
                }
              },
            );
          })
          .catch((err) => {
            this.setState({ loading: false });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage("Something went wrong", false);
            }
          });
      })
      .catch((err) => {
        this.setState({ loading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
      });
  }

  setTempPrice = (price, priceType) => {
    if (typeof price === "object") {
      return price;
    } else {
      let pr = {};
      if (priceType === "RC") {
        pr.recurringPrice = {
          termUomId: null,
          price: price,
        };
      }
      pr.purchasePrice = price;
      return pr;
    }
  };

  // This function is used to watch input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // This function is used to close tab
  closeTab = () => {
    this.props.setErrorMessage("", true);
    window.open("", "_parent", "");
    window.close();
  };

  // This function is used to accept order
  accept = () => {
    this.setState({ loading: true });
    let data = {
      orderId: this.state.orderId,
      token: this.state.token,
      status: "accepted",
      actionTime: new Date().getTime(),
      acted_by: this.state.acted_by,
      acted_title: this.state.acted_title,
      ipAddress: this.state.ipAddress,
      terms: this.state.terms,
    };
    // Accept terms & conditions and approve order
    BusApiCall(
      "POST",
      `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/orders/${this.state.orderId}/tncs`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          "Thank you for accepting the Order #" + this.state.orderId,
          true,
        );
        window.scrollTo(0, 0);
        this.setState({
          // tyMsg: "Thank you for accepting the order.",
          show: false,
          loading: false,
          showCloseButton: true,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({
          show: false,
          loading: false,
          showCloseButton: true,
        });
      });
  };

  // This function is used to reject order
  reject = () => {
    this.setState({ loading: true });
    let data = {
      orderId: this.state.orderId,
      token: this.state.token,
      status: "rejected",
      actionTime: new Date().getTime(),
      acted_by: this.state.acted_by,
      acted_title: this.state.acted_title,
      ipAddress: this.state.ipAddress,
      terms: this.state.terms,
    };
    // Reject terms & conditions and reject order
    BusApiCall(
      "POST",
      `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/orders/${this.state.orderId}/tncs`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          "You have rejected the Order #" + this.state.orderId,
          true,
        );
        window.scrollTo(0, 0);
        this.setState({
          show: false,
          loading: false,
          showCloseButton: true,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({
          show: false,
          loading: false,
          showCloseButton: true,
        });
      });
  };

  getBPMNActions = () => {
    const params = new URLSearchParams(this.props.router.location.search);
    // Get order id and token from URL params
    const token = params.get("token");
    let tenantId = params.get("tenantId");
    // Get order id from URL params
    this.setState({
      loading: true,
    });
    // Get order actions from flowable
    BusApiCall(
      "GET",
      `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/orders/${this.state.orderId}/flowable/bpmn/taskForms?token=${token}`,
    )
      .then((res) => {
        var formFields = res.data;
        if (formFields.fields && formFields.fields.length > 0) {
          for (var i = 0; i < formFields.fields.length; i++) {
            if (formFields.fields[i].value) {
              formFields.fields[i].value = null;
            }
          }
        }
        this.setState({
          taskFormData: formFields,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  changeFormField = (e) => {
    this.props.setErrorMessage("", false);
    var formFields = { ...this.state.taskFormData };
    var index = formFields.fields.findIndex(
      (input) => input.id === e.target.name,
    );
    if (index > -1) {
      if (formFields.fields[index].type === "boolean") {
        if (formFields.fields[index].value) {
          formFields.fields[index].value = false;
        } else {
          formFields.fields[index].value = true;
        }
      } else {
        if (
          formFields.fields[index].type === "integer" ||
          formFields.fields[index].type === "decimal"
        ) {
          var decimalNumberRegexp = /^-?\d+(\.\d{1,2})?$/;
          if (e.target.value) {
            var result = decimalNumberRegexp.test(e.target.value);
            if (result) {
              formFields.fields[index].value = e.target.value;
            }
          } else {
            formFields.fields[index].value = e.target.value;
          }
        } else {
          formFields.fields[index].value = e.target.value;
        }
      }
    }
    this.setState({
      taskFormData: formFields,
    });
  };

  submitTaskForm = (value) => {
    this.setState({ loading: true });
    var staticData = [
      {
        id: "orderId",
        value: this.state.orderId,
      },
      {
        id: "token",
        value: this.state.token,
      },
      {
        id: "actionTime",
        value: new Date().getTime(),
      },
      {
        id: "ipAddress",
        value: this.state.ipAddress,
      },
    ];

    bpmnFormValidator(this.state.taskFormData.fields).then((res) => {
      if (res === "valid") {
        this.setState({
          loading: true,
        });
        var payload = {
          taskId: this.state.taskFormData.taskId,
          properties: [],
        };
        for (var i = 0; i < this.state.taskFormData.fields.length; i++) {
          var input = {
            id: this.state.taskFormData.fields[i].id,
            value: this.state.taskFormData.fields[i].value,
          };
          payload.properties.push(input);
        }
        payload.properties = [...payload.properties, ...staticData];
        console.log("check final data", payload);
        // submit data
        //BusApiCall('POST', `${constants.busOpenServiceUrl}/tenants/${this.state.tenantId}/flowable/bpmn/taskForms?token=${this.state.token}`, payload).then(res => {

        BusApiCall(
          "POST",
          `${constants.busOpenServiceUrl}/flowable/bpmn/taskForms`,
          payload,
        )
          .then((res) => {
            // if (value === 'accepted') {
            //     this.props.setErrorMessage("Thank you for accepting the Order #" + this.state.orderId, true);
            // } else {
            //     this.props.setErrorMessage("You have rejected the Order #" + this.state.orderId, true);
            // }
            this.props.setErrorMessage(
              "Order #" + this.state.orderId + " updated successfully.",
              true,
            );
            window.scrollTo(0, 0);
            this.setState({
              show: false,
              loading: false,
              showCloseButton: true,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage("Something went wrong", false);
            }
            this.setState({
              show: false,
              loading: false,
              showCloseButton: true,
            });
          });
      } else {
        this.props.setErrorMessage(res, false);
        return false;
      }
    });
  };

  rejectTaskForm = () => {};

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <HeaderNoAuth />
        <main style={{ maxWidth: "1300px" }}>
          {this.state.show ? (
            <>
              {this.state.orderTermStatus !== "accepted" &&
              this.state.orderTermStatus !== "rejected" ? (
                <React.Fragment>
                  <h2 className={classes.checkoutTitle}>
                    {" "}
                    {`Confirm Order: #${this.state.orderId}`}
                  </h2>

                  {/* Show customer details component */}
                  <CustomerDetailBlock
                    stage={props.stage}
                    customerDetails={props.customerDetails}
                  />

                  <br />
                  <br />
                  {/* Show order items info compponent */}
                  <CartBlock
                    componentList={this.props.componentList}
                    solutionList={this.state.solutions}
                    accessoryList={this.state.accessories}
                    edit={{}}
                    orderStatus={this.state.orderStatus}
                    providerType={"SALES_CHNL_PROVIDER"}
                  />
                  <br />
                  <br />
                  {/* Show terms & Conditions component */}
                  <Tnc
                    terms={this.state.terms}
                    providerTitle={this.state.providerTitle}
                  />
                  {!this.state.workFlowEnabled && (
                    <>
                      <div>
                        <br />
                        <br />
                        <form autoComplete="off">
                          <p>
                            I,
                            <input
                              className={classes.termsUsername}
                              type="text"
                              name="acted_by"
                              value={this.state.acted_by}
                              placeholder={"Name"}
                              onChange={(event) => this.onChange(event)}
                            />{" "}
                            ,
                            <input
                              className={classes.termsUsername}
                              type="text"
                              name="acted_title"
                              value={this.state.acted_title}
                              placeholder={"Job Title"}
                              onChange={(event) => this.onChange(event)}
                            />
                            , on behalf of "
                            {this.state.customerDetails.accountName}" am
                            agreeing to all terms and conditions.
                          </p>
                        </form>
                        <br />
                        <br />
                      </div>
                      <div className={classes.stepButton}>
                        <Button
                          className={"buttonNoAuth"}
                          disabled={
                            !this.state.acted_by || !this.state.acted_title
                          }
                          onClick={() => {
                            this.reject();
                          }}
                        >
                          {"Reject Order"}
                        </Button>
                        <Button
                          className={"buttonNoAuth"}
                          disabled={
                            !this.state.acted_by || !this.state.acted_title
                          }
                          onClick={() => {
                            this.accept();
                          }}
                        >
                          {"Accept Order"}
                        </Button>
                      </div>
                    </>
                  )}
                  {this.state.workFlowEnabled && (
                    <>
                      {this.state.taskFormData.fields &&
                        this.state.taskFormData.fields.length > 0 && (
                          <>
                            <h1>{this.state.taskFormData.name}</h1>
                            <Grid
                              container
                              spacing={3}
                              style={{ marginTop: "15px" }}
                            >
                              {this.state.taskFormData.fields.map(
                                (input, index) => (
                                  <Grid
                                    item
                                    key={index}
                                    size={{
                                      xs: 12,
                                      md: 6,
                                    }}
                                  >
                                    <GenericBPMNForm
                                      input={input}
                                      onChange={this.changeFormField}
                                    />
                                  </Grid>
                                ),
                              )}
                            </Grid>

                            <div
                              className={classes.stepButton}
                              style={{ marginTop: "15px" }}
                            >
                              <Button
                                className={"buttonNoAuth"}
                                onClick={() => {
                                  this.submitTaskForm();
                                }}
                              >
                                {"Submit"}
                              </Button>
                            </div>
                          </>
                        )}
                    </>
                  )}
                </React.Fragment>
              ) : (
                <>
                  {/* If order has been already accepted/rejected block */}
                  <div style={{ textAlign: "center" }}>
                    <p>
                      Order <b>#{this.state.orderId}</b> is already{" "}
                      {this.state.orderTermStatus === "accepted"
                        ? "accepted"
                        : "rejected"}{" "}
                      or the link has been expired.
                      <br />
                      <br />
                      <Button
                        onClick={() => {
                          this.closeTab();
                        }}
                      >
                        Close Page
                      </Button>
                    </p>
                  </div>
                </>
              )}
            </>
          ) : this.state.tyMsg ? (
            <h2>{this.state.tyMsg}</h2>
          ) : this.state.showCloseButton ? (
            <div style={{ textAlign: "center" }}>
              <p>
                <Button
                  onClick={() => {
                    this.closeTab();
                  }}
                >
                  Close Page
                </Button>
              </p>
            </div>
          ) : null}
          <Loader loading={this.state.loading} />
        </main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    componentList: state.cart.componentList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setTenantId: (id) => dispatch({ type: actionTypes.SET_TENANT_ID, id }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmOrder);
